import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import Loader from 'Component/Loader';
import StarFavoriteIcon from 'Component/StarFavoriteIcon';
import { MixType } from 'Type/Common.type';
import { OrderType } from 'Type/Order.type';

import './MyAccountOrderFavoriteButton.style';

/** @namespace PeggysagePwa/Component/MyAccountOrderFavoriteButton/Component */
export class MyAccountOrderFavoriteButtonComponent extends PureComponent {
    static propTypes = {
        order: OrderType.isRequired,
        mix: MixType,
        isLoading: PropTypes.bool,
        isDisabled: PropTypes.bool,
        isFavorite: PropTypes.bool,
        onButtonClick: PropTypes.func.isRequired
    };

    static defaultProps = {
        mix: {},
        isLoading: false,
        isDisabled: false,
        isFavorite: false
    };

    renderButton() {
        const { isFavorite, isDisabled, onButtonClick } = this.props;

        const title = isFavorite ? __('Remove from favorites') : __('Add to favorites');

        return (
            <button
              block="MyAccountOrderFavoriteButton"
              elem="Button"
              mods={ { isFavorite, isDisabled } }
              // mix={ { block: 'Button' } }
              title={ title }
              onClick={ onButtonClick }
            >
                <StarFavoriteIcon isActive={ isFavorite } />
            </button>
        );
    }

    renderLoader() {
        const { isLoading } = this.props;

        return (
            <Loader isLoading={ isLoading } />
        );
    }

    renderContent() {
        const { mix } = this.props;

        return (
            <div block="MyAccountOrderFavoriteButton" mix={ mix }>
                { this.renderButton() }
                { this.renderLoader() }
            </div>
        );
    }

    render() {
        const { order } = this.props;

        if (!order) {
            return null;
        }

        return this.renderContent();
    }
}

export default MyAccountOrderFavoriteButtonComponent;
